export enum FormStatus {
  DRAFT = 'draft' /* 1 шаг «Настройте поля» / Добавление полей на форму*/,
  FILE_UPLOAD = 'file_upload' /* 2 шаг «Наполнение формы» / Загрузка файла*/,
  VALIDATION = 'validation' /* 3 шаг «Проверка и публикация» / Экран с предпросмотром и валидацией полей*/,
  PUBLISHED = 'published' /** форма опубликована*/,
  FINISHED = 'finished' /** Форма завершена ( полностью согласована ) */,
}
